import axios from 'axios';
import { toast } from 'react-toastify';

let hasShown403Toast = false;

// Request interceptor: agregar token automáticamente
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor: manejar errores 403
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 403) {
      const msg = error.response.data?.message || 'No tienes permiso para realizar esta acción';

      // Evitar spam de toasts si varias llamadas fallan al mismo tiempo
      if (!hasShown403Toast) {
        hasShown403Toast = true;
        toast.warning(msg, { toastId: 'permiso-403' });
        setTimeout(() => { hasShown403Toast = false; }, 3000);
      }

      // Marcar el error como de permisos para que los catch lo identifiquen
      (error as any).isPermissionError = true;
    }

    return Promise.reject(error);
  }
);

export default axios;
